import { render, staticRenderFns } from "./live_detail.vue?vue&type=template&id=18d06ebe&scoped=true"
import script from "./live_detail.vue?vue&type=script&lang=js"
export * from "./live_detail.vue?vue&type=script&lang=js"
import style0 from "./live_detail.vue?vue&type=style&index=0&id=18d06ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d06ebe",
  null
  
)

export default component.exports